import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PDialogService } from './p-dialog.service';

// MatDialog requeres to be injected eithin the contxt that open the dialog
// It is important for the injector of the component displayed within the dialog
export function injectPDialog() {
    const dialog: MatDialog = inject(MatDialog);
    // todo destroy
    return new PDialogService(dialog);
}
